import React from 'react'

const SmallBox = ({color, title, amount, linkTitle, onPress = () => {} }) => {
    return (
        <div className={`small-box ${color}`}>
            <div className="inner">
                <h3>{amount}</h3>
                <p>{title}</p>
            </div>
            <button
                type="button"
               onClick={onPress}
                style={{border: 'none', width: '100%'}}
               className="small-box-footer link-light link-underline-opacity-0 link-underline-opacity-50-hover">
                {linkTitle} <i className="bi bi-arrow-right"></i>
            </button>
        </div>
    )
}

export default SmallBox